import LocalStorageService from "../local_storage_service";

class LocalStorageServiceImpl extends LocalStorageService {
    static #instance = null; // Private static instance

    constructor() {
        if (LocalStorageServiceImpl.#instance) {
            return LocalStorageServiceImpl.#instance; // Return existing instance
        }
        super();
        LocalStorageServiceImpl.#instance = this; // Store instance
    }

    async saveData(key, data) {
        localStorage.setItem(key, data);
    }

    async getData(key) {
        return localStorage.getItem(key) || "";
    }

    async deleteData(key) {
        localStorage.removeItem(key);
    }
}

export default LocalStorageServiceImpl;